import {
	RequestFreightQuoteSendMutation,
	RequestPlannedArrivalNoticesMutation,
	RequestPlannedArrivalNoticesMutationVariables,
	ResolveUncertainLoadEmailMutation
} from "~/gql/mutations/fulfill/logisticsLoads.generated";
import {
	GetFreightQuoteSendStatusQuery,
	GetFreightQuoteSendStatusQueryVariables,
	GetLoadStopNoticeStatusQuery,
	GetLoadStopNoticeStatusQueryVariables
} from "~/gql/queries/fulfill/logisticsLoads.generated";

export const logisticsLoadEndpoints = {
	ApplyLoadFreight: { invalidatesTags: ["Orders"] as AddTagTypes },
	GetFreightQuoteSendStatus: {
		providesTags: (
			_res: GetFreightQuoteSendStatusQuery | undefined,
			_err: unknown,
			arg: GetFreightQuoteSendStatusQueryVariables
		) => [{ id: arg.loadId, type: "FreightQuoteSendStatus" as const }],
		transformResponse: (res: GetFreightQuoteSendStatusQuery) => res
	},
	GetLoadStopNoticeStatus: {
		providesTags: (
			_res: GetLoadStopNoticeStatusQuery | undefined,
			_err: unknown,
			arg: GetLoadStopNoticeStatusQueryVariables
		) => [{ id: arg.loadId, type: "LoadStopNoticeStatus" as const }],
		transformResponse: (res: GetLoadStopNoticeStatusQuery) => res
	},
	PreviewLoadFreight: { keepUnusedDataFor: 0 },
	RequestFreightQuoteSend: {
		invalidatesTags: ["FreightQuoteSendStatus"] as AddTagTypes,
		transformResponse: (res: RequestFreightQuoteSendMutation) => res
	},
	RequestPlannedArrivalNotices: {
		invalidatesTags: (
			_res: RequestPlannedArrivalNoticesMutation | undefined,
			_err: unknown,
			arg: RequestPlannedArrivalNoticesMutationVariables
		) => [{ id: arg.input.loadId, type: "LoadStopNoticeStatus" as const }],
		transformResponse: (res: RequestPlannedArrivalNoticesMutation) => res
	},
	// ResolveUncertainLoadEmailInput carries only a reservationId, so invalidate every load's status instead of one load id.
	ResolveUncertainLoadEmail: {
		invalidatesTags: ["LoadStopNoticeStatus", "FreightQuoteSendStatus"] as AddTagTypes,
		transformResponse: (res: ResolveUncertainLoadEmailMutation) => res
	}
};
